import { useEffect, useState } from "react";

const KEY = "showBarcodeValueInLabPrint";
const EVENT_NAME = "showBarcodeValueInLabPrintChanged";

// eslint-disable-next-line import/prefer-default-export
export const useShowBarcodeValueInLabPrint = (): {
  showBarcodeValueInLabPrint: boolean;
  setShowBarcodeValueInLabPrint: (value: boolean) => void;
} => {
  const [showBarcodeValueInLabPrint, setShowBarcodeValueInLabPrint] = useState<boolean>(() => {
    const stored = localStorage.getItem(KEY);
    return stored === null ? false : stored === "true";
  });

  // use effects
  useEffect(() => {
    localStorage.setItem(KEY, String(showBarcodeValueInLabPrint));
    window.dispatchEvent(new Event(EVENT_NAME));
  }, [showBarcodeValueInLabPrint]);

  useEffect(() => {
    const sync = () => {
      setShowBarcodeValueInLabPrint(localStorage.getItem(KEY) === "true");
    };

    const handleStorage = (e: StorageEvent) => {
      if (e.key === KEY) {
        sync();
      }
    };

    window.addEventListener(EVENT_NAME, sync);
    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener(EVENT_NAME, sync);
      window.removeEventListener("storage", handleStorage);
    };
  }, []);

  return { showBarcodeValueInLabPrint, setShowBarcodeValueInLabPrint };
};
